<div>
  <p>{{ 'OPENING_HOURS_EXPLANATION_PART_1' | translate }}</p>
  <p>{{ 'OPENING_HOURS_EXPLANATION_PART_2' | translate }}</p>
</div>

<!-- Regular opening hours -->
<div class="row">
  <div class="col-12">
    <button class="btn-bulk-action btn btn-info" (click)="setAlwaysOpen()">
      {{ 'OPENING_HOURS_BULK_ACTION_OPEN_24_HOURS' | translate }}
    </button>
  </div>

  <!-- Validation errors -->
  <div class="col-12">
    <div class="alert alert-danger mt-4" *ngIf="errors?.min">
      {{ 'MINIMUM_X_HOURS_PREFIX' | translate }} {{ minHours }} {{ 'MINIMUM_X_HOURS_SUFFIX' | translate }}
    </div>
  </div>

  <!-- Monday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.monday"
    (openingHoursChange)="onChange($event)"
    [heading]="'MONDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('monday', 'tuesday')"
      [disabled]="!hasValidHours('monday')"
    >
      <i class="icon-copy-down"></i>{{ 'COPY_TO_NEXT' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('monday')" [disabled]="!hasValidHours('monday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Tuesday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.tuesday"
    (openingHoursChange)="onChange($event)"
    [heading]="'TUESDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('tuesday', 'monday')"
      [disabled]="!hasValidHours('tuesday')"
    >
      <i class="icon-copy-up"></i>{{ 'COPY_TO_PREVIOUS' | translate }}
    </button>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('tuesday', 'wednesday')"
      [disabled]="!hasValidHours('tuesday')"
    >
      <i class="icon-copy-down"></i>{{ 'COPY_TO_NEXT' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('tuesday')" [disabled]="!hasValidHours('tuesday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Wednesday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.wednesday"
    (openingHoursChange)="onChange($event)"
    [heading]="'WEDNESDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('wednesday', 'tuesday')"
      [disabled]="!hasValidHours('wednesday')"
    >
      <i class="icon-copy-up"></i>{{ 'COPY_TO_PREVIOUS' | translate }}
    </button>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('wednesday', 'thursday')"
      [disabled]="!hasValidHours('wednesday')"
    >
      <i class="icon-copy-down"></i>{{ 'COPY_TO_NEXT' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('wednesday')" [disabled]="!hasValidHours('wednesday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Thursday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.thursday"
    (openingHoursChange)="onChange($event)"
    [heading]="'THURSDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('thursday', 'wednesday')"
      [disabled]="!hasValidHours('thursday')"
    >
      <i class="icon-copy-up"></i>{{ 'COPY_TO_PREVIOUS' | translate }}
    </button>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('thursday', 'friday')"
      [disabled]="!hasValidHours('thursday')"
    >
      <i class="icon-copy-down"></i>{{ 'COPY_TO_NEXT' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('thursday')" [disabled]="!hasValidHours('thursday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Friday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.friday"
    (openingHoursChange)="onChange($event)"
    [heading]="'FRIDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('friday', 'thursday')"
      [disabled]="!hasValidHours('friday')"
    >
      <i class="icon-copy-up"></i>{{ 'COPY_TO_PREVIOUS' | translate }}
    </button>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('friday', 'saturday')"
      [disabled]="!hasValidHours('friday')"
    >
      <i class="icon-copy-down"></i>{{ 'COPY_TO_NEXT' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('friday')" [disabled]="!hasValidHours('friday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Saturday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.saturday"
    (openingHoursChange)="onChange($event)"
    [heading]="'SATURDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('saturday', 'friday')"
      [disabled]="!hasValidHours('saturday')"
    >
      <i class="icon-copy-up"></i>{{ 'COPY_TO_PREVIOUS' | translate }}
    </button>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('saturday', 'sunday')"
      [disabled]="!hasValidHours('saturday')"
    >
      <i class="icon-copy-down"></i>{{ 'COPY_TO_NEXT' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('saturday')" [disabled]="!hasValidHours('saturday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Sunday -->
  <lh-opening-hours-picker
    class="col-12"
    [(openingHours)]="openingHours.sunday"
    (openingHoursChange)="onChange($event)"
    [heading]="'SUNDAY' | translate"
  >
  </lh-opening-hours-picker>
  <div class="col-12 copy-buttons">
    <span class="copy-to">{{ 'COPY_TO' | translate }}</span>
    <button
      class="btn btn-sm btn-default"
      (click)="copyHours('sunday', 'saturday')"
      [disabled]="!hasValidHours('sunday')"
    >
      <i class="icon-copy-up"></i>{{ 'COPY_TO_PREVIOUS' | translate }}
    </button>
    <button class="btn btn-sm btn-default" (click)="copyHours('sunday')" [disabled]="!hasValidHours('sunday')">
      <i class="icon-copy-all"></i>{{ 'COPY_TO_ALL' | translate }}
    </button>
  </div>

  <!-- Validation errors -->
  <div class="col-12">
    <div class="alert alert-danger mt-4" *ngIf="errors?.min">
      {{ 'MINIMUM_X_HOURS_PREFIX' | translate }} {{ minHours }} {{ 'MINIMUM_X_HOURS_SUFFIX' | translate }}
    </div>
  </div>
</div>
